import {createServerFn} from '@tanstack/start'
import {getHeader} from 'vinxi/http'
import parser from 'accept-language-parser'
import {Locale} from '~/gql/graphql'

export const AVAILABLE_LOCALES_MAP: Record<string, Locale> = {
    en: Locale.EnEu,
    de: Locale.DeDe,
}

const getPreferredLocale = createServerFn({
    method: 'GET',
}).handler(async () => {
    const acceptLanguage = getHeader('Accept-Language')
    if (!acceptLanguage) {
        return Locale.EnEu
    }

    const language = parser.pick(['en', 'de'], acceptLanguage, {loose: true})
    return AVAILABLE_LOCALES_MAP[language ?? ''] ?? Locale.EnEu
})

export default getPreferredLocale
